import { useEffect, useState } from 'react'

export const useDesktopAppListener = (
  channel: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listener: (args: any[]) => void,
  postRegisterCallback?: () => void | null,
) => {
  const [foundElectronApi, setFoundElectronApi] = useState(false)

  useEffect(
    () => {
      if (!window.electronAPI) {
        return
      }

      const unregisterListener = window.electronAPI.onMessageFromMainProcess(
        channel,
        listener,
      )

      if (postRegisterCallback) {
        postRegisterCallback()
      }

      setFoundElectronApi(true)

      return () => {
        unregisterListener()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return foundElectronApi
}
